"use client";
import { FileTypeIcon as e } from "../file-types/FileTypeIcon.js";
import { IconButton as t } from "../icon-button/IconButton.js";
import { FolderPlusIcon as n } from "../icons/FolderPlusIcon.js";
import { ProgressRing as r } from "../status-icons/ProgressRing.js";
import { XCloseIcon as i } from "../icons/XCloseIcon.js";
import { Popover as a } from "../popover/Popover.js";
import { FileTypeHelper as o } from "../file-types/file-type-helper.js";
import { FileUploadHelper as s } from "../file-upload/file-upload-helper.js";
import { Download01Icon as c } from "../icons/Download01Icon.js";
import { FolderCheckIcon as l } from "../icons/FolderCheckIcon.js";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
import f from "clsx";
//#region src/components/attachment/AttachmentCard.tsx
function p({ item: p, onPreview: m, onRetry: h, onRemove: g, onDownload: _, saveConfig: v, className: y, previewConfig: b }) {
	let x = p.upload, S = !x || x.status === "ready", C = x?.status === "failed", w = C ? h : S ? m : void 0, T = p.kind === "folder" ? "folder" : p.kind === "image" || p.mediaType?.startsWith("image/") ? "image" : o.fromFilename(p.filename), E = C ? x.error : x?.status === "uploading" ? "Uploading…" : [p.kind === "folder" ? "Folder" : p.filename.split(".").at(-1)?.toUpperCase(), p.size === void 0 ? void 0 : s.size(p.size)].filter(Boolean).join(" · ");
	return /* @__PURE__ */ d("div", {
		"data-pf-attachment": "",
		"data-layout": "card",
		"data-status": x?.status ?? "ready",
		className: f("pf:box-border pf:relative pf:flex pf:w-full pf:min-w-0 pf:min-h-[64px] pf:items-center pf:gap-lg pf:rounded-lg pf:border-[0.5px] pf:border-solid pf:bg-background pf:p-lg pf:font-body pf:[@media(hover:hover)]:hover:bg-soft-pearl-200 pf:focus-within:bg-soft-pearl-200 pf:transition-none pf:duration-(--pf-duration-instant) pf:ease-(--pf-easing-out) pf:motion-reduce:transition-none", C ? "pf:border-red-300" : "pf:border-soft-pearl-300", y),
		children: [
			/* @__PURE__ */ u(e, {
				size: 40,
				kind: T
			}),
			/* @__PURE__ */ d("div", {
				className: "pf:min-w-0 pf:flex-1",
				children: [w ? b && S ? /* @__PURE__ */ u(a, {
					mode: "preview",
					title: p.filename,
					loadingConfig: { isLoading: b.isLoading ?? !1 },
					trigger: /* @__PURE__ */ u("button", {
						type: "button",
						onClick: () => {
							w(p);
						},
						className: "pf:block pf:w-full pf:truncate pf:border-0 pf:bg-transparent pf:p-0 pf:text-start pf:font-body pf:text-label-13-strong pf:text-soft-pearl-1000 pf:cursor-pointer pf:after:absolute pf:after:inset-0 pf:after:rounded-lg pf:focus-visible:outline-2 pf:focus-visible:outline-blue-700",
						children: p.filename
					}),
					children: b.content
				}) : /* @__PURE__ */ u("button", {
					type: "button",
					onClick: () => {
						w(p);
					},
					className: "pf:block pf:w-full pf:truncate pf:border-0 pf:bg-transparent pf:p-0 pf:text-start pf:font-body pf:text-label-13-strong pf:text-soft-pearl-1000 pf:cursor-pointer pf:after:absolute pf:after:inset-0 pf:after:rounded-lg pf:focus-visible:outline-2 pf:focus-visible:outline-blue-700",
					children: p.filename
				}) : /* @__PURE__ */ u("div", {
					title: p.filename,
					className: "pf:truncate pf:text-label-13-strong pf:text-soft-pearl-1000",
					children: p.filename
				}), /* @__PURE__ */ u("div", {
					role: C ? "status" : void 0,
					className: f("pf:mt-xxs pf:text-copy-12 pf:wrap-anywhere", C ? "pf:text-red-800" : "pf:text-soft-pearl-800"),
					children: E
				})]
			}),
			/* @__PURE__ */ d("div", {
				className: "pf:relative pf:flex pf:shrink-0 pf:items-center pf:gap-xs",
				children: [
					x?.status === "uploading" && /* @__PURE__ */ u(r, {
						value: x.progress,
						label: `Uploading ${p.filename}`
					}),
					S && v && /* @__PURE__ */ u(t, {
						size: "sm",
						label: v.isSaved ? "Saved to Documents" : "Save to Documents",
						disabled: v.isSaved ? !v.onOpen : !v.onSave,
						onClick: () => v.isSaved ? v.onOpen?.(p) : v.onSave?.(p),
						children: v.isSaved ? /* @__PURE__ */ u(l, {}) : /* @__PURE__ */ u(n, {})
					}),
					S && _ && /* @__PURE__ */ u(t, {
						size: "sm",
						label: `Download ${p.filename}`,
						onClick: () => {
							_(p);
						},
						children: /* @__PURE__ */ u(c, {})
					}),
					g && /* @__PURE__ */ u(t, {
						size: "sm",
						label: `Remove ${p.filename}`,
						onClick: () => {
							g(p);
						},
						children: /* @__PURE__ */ u(i, {})
					})
				]
			})
		]
	});
}
//#endregion
export { p as AttachmentCard };
